const mutations = {
  LOGINSHOW(state, value) {
    state.loginshow = value
  },
  LOGINSTATE(state, value) {
    state.loginstate = value
  },
  LOG(state, value) {
    state.log = value
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js